import {Component, Input, OnInit} from '@angular/core';
import {BranchMathValve} from "../branch-type-math-valve/ValveMathStruct";
import {BranchConstant, BranchMeasurement} from "../../CardStruct";
import {BranchZoneStruct} from "./BranchZoneStruct";
import {VariableValue} from "../../../variableDataBase/VariableValue";
import {VariableDataBase} from "../../../variableDataBase/variable-data-base.service";
import {sprintf} from "sprintf-js";

@Component({
  selector: 'app-branch-type-zone-overview',
  templateUrl: './branch-type-zone-overview.component.html',
  styleUrls: ['./branch-type-zone-overview.component.css']
})
export class BranchTypeZoneOverviewComponent implements OnInit {
  @Input() branchZoneOverview: BranchZoneStruct | undefined;

  solarsumstart: &VariableValue = new VariableValue();
  solarsetpoint: &VariableValue = new VariableValue();
  solarsummation: &VariableValue = new VariableValue();
  repeattimercount: &VariableValue = new VariableValue();
  repeattimesetpoint: &VariableValue = new VariableValue();
  nrruntoday: &VariableValue = new VariableValue();
  watertoday: &VariableValue = new VariableValue();
  startprogram: &VariableValue = new VariableValue();
  unitnumber: &VariableValue = new VariableValue();
  destinationtank: &VariableValue = new VariableValue();
  sourcetank: &VariableValue = new VariableValue();

  repeatpresent: &VariableValue = new VariableValue();
  solarpresent: &VariableValue = new VariableValue();


  constructor(private variableDB: VariableDataBase) { }

  TestRepeatStartActive() : boolean
  {
    if(this.branchZoneOverview) {
      if( this.branchZoneOverview.repeatpresent)
          return (this.repeattimesetpoint.val > 0) ? true : false;
    }
    return false;
  }

  TestSolarStartActive() : boolean
  {
    if(this.branchZoneOverview) {
      if( this.branchZoneOverview.solarpresent)
        return (this.solarsetpoint.val > 0) ? true : false;
    }
    return false;
  }

  GetValue(variable: VariableValue) : string
  {
    if(variable.IsInvalid())
      return "NaN";
    return sprintf("%5f", variable.val / 1);
  }

  GetTankClass(variable: VariableValue) : string
  {
    if(variable.IsInvalid())
      return "red";

    var colors = ['cyan', 'green', 'blue', 'orange', 'yellow','purple'];
    return colors[variable.val % colors.length];

  }

  ShowTank() : boolean
  {
    return true;
  }

  TestRepeat() : boolean
  {
    return true;
    // if(this.branchZoneOverview) {
    //   if( this.branchZoneOverview.repeatpresent)
    //     return (this.repeattimesetpoint.val > 0) ? true : false;
    // }
  //  return false;
//
  }




  ngOnInit(): void {
    if( this.branchZoneOverview ) {

      this.solarsumstart          = this.variableDB.AddValueByReference(this.branchZoneOverview.solarsumstart       .variable.id);
      this.solarsetpoint          = this.variableDB.AddValueByReference(this.branchZoneOverview.solarsetpoint       .variable.id);
      this.solarsummation         = this.variableDB.AddValueByReference(this.branchZoneOverview.solarsummation      .variable.id);
      this.repeattimercount       = this.variableDB.AddValueByReference(this.branchZoneOverview.repeattimercount    .variable.id);
      this.repeattimesetpoint     = this.variableDB.AddValueByReference(this.branchZoneOverview.repeattimesetpoint  .variable.id);
      this.nrruntoday             = this.variableDB.AddValueByReference(this.branchZoneOverview.nrruntoday          .variable.id);
      this.watertoday             = this.variableDB.AddValueByReference(this.branchZoneOverview.watertoday          .variable.id);
      this.startprogram           = this.variableDB.AddValueByReference(this.branchZoneOverview.startprogram        .variable.id);
      this.unitnumber             = this.variableDB.AddValueByReference(this.branchZoneOverview.unitnumber          .variable.id);
      this.destinationtank        = this.variableDB.AddValueByReference(this.branchZoneOverview.destinationtank     .variable.id);
      this.sourcetank             = this.variableDB.AddValueByReference(this.branchZoneOverview.sourcetank          .variable.id);
    }
  }


}
